var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09375 0.951172L11.0449 5.87695C11.2734 6.13086 11.2734 6.51172 11.0449 6.74023L10.4609 7.32422C10.2324 7.55273 9.85156 7.55273 9.59766 7.32422L5.6875 3.41406L1.75195 7.32422C1.49805 7.55273 1.11719 7.55273 0.888672 7.32422L0.304688 6.74023C0.0761719 6.51172 0.0761719 6.13086 0.304688 5.87695L5.25586 0.951172C5.48438 0.722656 5.86523 0.722656 6.09375 0.951172Z",
    fill: "#002C3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.9b7f3d69ba0f67fb4f05bc72d1aa5b02.svg";
export { ForwardRef as ReactComponent };